import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import BestZantacLawyersWrapper from "@components/layouts/bestzantaclawyersWrapper";

export default function BestZantacLawyersHome(): ReactElement {
    return (
        <BestZantacLawyersWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="Zantac"
                    domain="BestZantacLawyers.com"
                />
            </div>
        </BestZantacLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
